import React from 'react';
import { View, Text, I18nManager } from 'react-native';
import GatsbyLink from 'gatsby-link';
import './style.css';

import * as lang from '../lang';
import * as comp from './pages';
import Footer from './footer';
import Header from './header';
import Helmet from './helmet';

const connect = (comp_name, selected_lang) => () => {
  const Comp = comp[comp_name];
  const page = comp_name.replace('HOME', '');
  return (
    <View style={{ flex: 1, alignItems: 'center', minHeight: '100%' }}>
      <View style={{ maxWidth: 840, flex: 1, width: '100%', paddingHorizontal: 20 }}>
        <Helmet lang={lang[selected_lang]} page={page} />
        <Header lang={lang[selected_lang]} page={page} />
        <View style={[{ flex: 1 }, page && { backgroundColor: 'white', borderWidth: 1, borderStyle: 'solid', borderColor: '#eeee', padding: 50 }]}>
          <Comp lang={lang[selected_lang]} />
        </View>
        <Footer lang={lang[selected_lang]} />
      </View>
    </View>
  );
};

export default connect;



// WEBPACK FOOTER //
// ./src/comp/connect.js